module.exports = __webpack_public_path__ + "static/media/icons8-microsoft-excel.8901eac8.svg";